"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var isSupported = function isSupported() {
  if (typeof Storage !== 'undefined') return true;
  return false;
};
var convertToString = function convertToString(value) {
  if (value && (0, _typeof2["default"])(value) === 'object') return JSON.stringify(value);
  return value;
};
var parseValue = function parseValue(value) {
  try {
    if (value) return JSON.parse(value);
    return value;
  } catch (err) {
    return value;
  }
};
var addItem = function addItem(key, value) {
  return localStorage.setItem(key, convertToString(value));
};
var getItem = function getItem(key) {
  return parseValue(localStorage.getItem(key));
};
var removeItem = function removeItem(key) {
  return localStorage.removeItem(key);
};
var storage = {
  isSupported: isSupported,
  addItem: addItem,
  getItem: getItem,
  removeItem: removeItem
};
var _default = exports["default"] = storage;